import type {
    CustomField,
    CustomFieldType,
    CustomFieldCollectionType,
    CustomFieldSystemType,
} from '@atlassian/help-center-common-component/forge-ui/types';
import type { FieldType } from 'state/persisted/request-create/types';

const fieldMap: Record<CustomFieldCollectionType, Partial<Record<CustomFieldSystemType, FieldType>>> = {
    none: {
        string: 'text',
        number: 'text',
        object: 'textarea',
        user: 'userpicker',
        datetime: 'datetime',
        date: 'date',
    },
    list: {
        string: 'labelpicker',
        user: 'multiuserpicker',
    },
};

export const getMappedFieldType = (extension: CustomField | CustomFieldType): FieldType => {
    const collection: CustomFieldCollectionType = extension.properties.collection === 'list' ? 'list' : 'none';
    return fieldMap[collection][extension.properties.type] || 'unknown';
};
